import { render, staticRenderFns } from "./placeholder-product-slider.vue?vue&type=template&id=18d4e49d&scoped=true&"
import script from "./placeholder-product-slider.vue?vue&type=script&lang=js&"
export * from "./placeholder-product-slider.vue?vue&type=script&lang=js&"
import style0 from "./placeholder-product-slider.vue?vue&type=style&index=0&id=18d4e49d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4e49d",
  null
  
)

export default component.exports